import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'shared-message-sender',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './message-sender.component.html',
  styleUrl: './message-sender.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageSenderComponent {
  sender = input.required<string>();
}
